import API from './api';

export const createSite = async (siteData) => {
  try {
    const response = await API.post('/sites', siteData);
    return response.data;
  } catch (error) {
    console.error('Error creating site:', error);
    throw error;
  }
};

export const getSites = async (showArchived = false) => {
  try {
    const response = await API.get(`/sites${showArchived ? '?archived=true' : ''}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sites:', error);
    throw error;
  }
};

export const updateSite = async (siteId, siteData) => {
  try {
    const response = await API.put(`/sites/${siteId}`, siteData);
    return response.data;
  } catch (error) {
    console.error('Error updating site:', error);
    throw error;
  }
};

export const archiveSite = async (siteId) => {
  try {
    const response = await API.post(`/sites/${siteId}/archive`);
    return response.data;
  } catch (error) {
    console.error('Error archiving site:', error);
    throw error;
  }
};

export const unarchiveSite = async (siteId) => {
  try {
    const response = await API.post(`/sites/${siteId}/unarchive`);
    return response.data;
  } catch (error) {
    console.error('Error unarchiving site:', error);
    throw error;
  }
};
